import { call, put, select, takeLatest } from "redux-saga/effects";

import { fetchConvertToWin } from "../../../../services/iqApiV2";
import {
  CONVERT_TO_WIN_REQUEST,
  fetchConvertToWinFailure,
  fetchConvertToWinSuccess,
} from "../../actions/opportunities/convertToWinAction";



// Worker Saga
function* fetchConvertToWinSaga() {
  try {
    const payload = yield select(
      (state) => state?.convertToWinReducer?.payload
    );
    const { ids, userId } = payload;
    const data = yield call(fetchConvertToWin, ids, userId);
    yield put(fetchConvertToWinSuccess(data));
  } catch (error) {
    yield put(fetchConvertToWinFailure(error.message));
  }
}

// Watcher Saga
export function* watchConvertToWinSaga() {
  yield takeLatest(CONVERT_TO_WIN_REQUEST, fetchConvertToWinSaga);
}
